import styled from 'styled-components';

import { media } from 'styles/utils';

export const ContentBlockWithSidebarContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 48px;

  ${media.tablet`
    grid-template-columns: 1fr 1fr;
  `}
`;

export const ContentBlockWithSidebarSidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  flex-shrink: 0;
`;
